var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as SlideFactory from '../../../classes/definitions/slide/slide';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import Config from '../../../config/config';
import slideSchema from '../../../schemas/slideSchema';
import Input from '../../UI/Input/Input';
// this component is used for both slides on the home page and brand slides
var PromoSlideForm = /** @class */ (function (_super) {
    __extends(PromoSlideForm, _super);
    function PromoSlideForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.imageChanged = false; // this will determine if the image has been changed
        // if no changes, no image prop will be sent to the backend
        _this.state = {
            formConfig: _.cloneDeep(slideSchema),
            formIsValid: false,
            discardPopupVisble: false,
        };
        _this.getSlide = function () {
            var actionMethod = _this.api.getPromoSlide(_this.editId);
            actionMethod
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане слайд';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var slide = SlideFactory.createSlide(_.get(data, 'attributes', {}));
            var imageUrl = slide.ImageUrl ? Config.cdnDomain + slide.ImageUrl : null;
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'link.value', slide.Link);
            _.set(updatedFormConfig, 'link.touched', true);
            _.set(updatedFormConfig, 'link.valid', true);
            _.set(updatedFormConfig, 'position.value', slide.Position ? slide.Position : null);
            _.set(updatedFormConfig, 'position.touched', true);
            _.set(updatedFormConfig, 'position.valid', true);
            _.set(updatedFormConfig, 'image.value', imageUrl);
            _.set(updatedFormConfig, 'image.touched', true);
            _.set(updatedFormConfig, 'image.valid', true);
            _.set(updatedFormConfig, 'seo_name.value', slide.SeoName);
            _.set(updatedFormConfig, 'seo_name.touched', true);
            _.set(updatedFormConfig, 'seo_name.valid', true);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            if (id === 'image' && updatedFormElement.valid) {
                _this.imageChanged = true;
            }
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedSlide = new FormData();
            var image = _.get(formData, 'image.value', null);
            submittedSlide.append('promo_slide[link]', _.get(formData, 'link.value', ''));
            submittedSlide.append("promo_slide[position]", _.get(formData, 'position.value', ''));
            submittedSlide.append("promo_slide[seo_name]", _.get(formData, 'seo_name.value', ''));
            if (_this.editId && _this.imageChanged && !image) {
                submittedSlide.append('promo_slide[remove_image]', '1');
            }
            else if (_this.editId && _this.imageChanged && image) {
                submittedSlide.append('promo_slide[image]', image);
            }
            var actionMethod = _this.editId !== "-1" ? _this.api.updatePromoSlide(submittedSlide, _this.editId) : _this.api.createPromoSlide(submittedSlide);
            actionMethod
                .then(function (response) {
                _this.toSlidesPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на слайд';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toSlidesPage = function () {
            _this.props.history.push(AppRoutes.promoSlides.path);
        };
        return _this;
    }
    PromoSlideForm.prototype.componentDidMount = function () {
        this.editId = _.get(this.props, 'match.params.id', '-1');
        if (this.editId !== '-1') {
            this.getSlide();
        }
    };
    PromoSlideForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray
            .filter(function (formElement) { return formElement.id !== 'video_idx'; }) // Exclude `video_idx` entirely
            .map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange'); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur'); } }));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toSlidesPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            actionBtns));
    };
    return PromoSlideForm;
}(React.Component));
// @ts-ignore
export default withRouter(PromoSlideForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/Slides/PromoSlideForm/PromoSlideForm.tsx
// module id = 417
// module chunks = 0